<style scoped>
    @import url("../../../styles/smartControl/estadoAtu.scss");
</style>

<template>
    <div class="box_estadoAtu">

        <div class="painelAtu">

            <div class="eCol">

                <!-- LOADING -->
                <div v-if="flagLoading" class="mb-16 mt-16"
                :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
                    <v-progress-circular 
                        color="black"
                        size="64"
                        indeterminate
                    ></v-progress-circular>
                </div>

                <div class="searchBar mt-1 mb-1" v-if="!flagLoading">

                    <!-- block | density="compact" | size="small" "default" | density="comfortable" size="small" -->
                    <v-btn 
                    @click="init()"
                    class="mb-2"
                    :style="{'color':corBtnRefresh}"
                    icon
                    @mouseover="corBtnRefresh='#F39C12'"
                    @mouseleave="corBtnRefresh='#1F7AB1'"
                    >
                        <!-- <span>Atualizar</span> -->
                        <v-icon icon class="" size="32">mdi-update</v-icon>
                    </v-btn>
                </div>
            </div>

            <div class="dCol" v-if="!flagLoading">

                <ExibAtu v-for="(el,i) in liGeralAtus" :key="i"
                :t="el.titulo"
                :statusAtu="el.status_atuador"
                :date="el.utc_str_last_status_set"
                :flagSinc="flagSinc"
                />

            </div>

        </div>

    </div>
</template>

<script>
import axios from 'axios'
import ExibAtu from './ExibAtu'

export default {

    components:{ExibAtu},

    props:['execSys'],

    data() {
        return {
            flagLoading:true,

            // father
            atuSelected:'',
            liAtus:[],
            liGeralAtus:[],
            hoverSearch:'#f39c12',
            corBtnRefresh:'#1F7AB1',

            // child (d)
            t:'',
            statusAtu:'Desligado',
            date:'16/12/2025-11:59',
            flagSinc:false,
            //corStatus:'',
        }
    },

    methods:{

        init() {
            this.flagLoading = true
            this.flagSinc = false // -- DESabilitar exibição no componente filho ExibAtu.vue

            // reset
            this.liGeralAtus = []
            this.liAtus = []

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let emailCliente = self.$store.state.emailCliente
            let params = {'cliente':emailCliente, 'sistema':self.execSys} // rcv sys via props
            let url = self.$store.state.pathAxiosBASE + '/statusatus' // 17/12/2025

            axios.post(url, params, {headers}).then(function (res) {

                console.log(res.data)
                self.liGeralAtus = res.data
                
                //console.log('self.liGeralAtus: ',self.liGeralAtus)
                self.flagLoading = false // -- habilitar select
                self.flagSinc = true // abrir for exib atus
            })
        }
    },

    created() {
        //console.log('[props] execSys: ',this.execSys)
        this.init()
    }
}
</script>